import { LeavePageModalComponent } from '../leave-page-modal/leave-page-modal.component';
import { MapfreModalComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { ModalOptions } from '@mapfre-design-library/src/public_api';
import { Router, NavigationStart , RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';


@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreButtonComponent, MapfreModalComponent, LeavePageModalComponent],
  selector: 'app-upload-request-documents',
  templateUrl: './upload-request-documents.component.html',
  styleUrls: ['./upload-request-documents.component.scss']
})
export class UploadRequestDocumentsComponent implements OnInit,OnDestroy {
  @Output() uploadFileEvent: EventEmitter<File[]> = new EventEmitter();
  @ViewChild('fileUpload') fileUpload!: ElementRef;

  private navigationSubscription: Subscription;
  pendingNavigationUrl: string;
  documents: File[] = [];
  loader: boolean;
  showTooLargeFileModal: boolean;
  showDeleteFileModal: boolean;
  showLeaveModal: boolean;
  uploadFilesModal: ModalOptions;
  hideModal = false;
  isLeavePage: boolean;
  indxFiletoDelete: number;

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
    this.showTooLargeFileModal = false;
    this.showDeleteFileModal = false;
    this.showLeaveModal = false;
    this.setModal()

    window.addEventListener('beforeunload', this.preventPageLeave);
    this.navigationSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.handleNavigation(event);
      }
    });
  }

  setModal() {
    this.uploadFilesModal = new ModalOptions({
      additionalClasses:
        'modal-lg modal-dialog center-on-page confirm-modal email-update edit-contact-modal',
      animatePosition: 'top',
      onLoad: true,
      modalId: 'uploadFilesModal',
      iconClasses: 'far fa-user-circle',
      iconFamily: 'font-awesome',
      size: 'modal-lg',
      modalName: 'upload_Files_Modal',
    });
  }

  handleNavigation(event: NavigationStart): void {
    if (this.documents.length && !this.isLeavePage) {
      this.pendingNavigationUrl = event.url;
      this.showLeaveModal = true;

      this.router.navigateByUrl(this.router.url);
    }
  }

  preventPageLeave = (event: any): void =>{
    if (this.documents.length  && !this.isLeavePage) {
      event.returnValue = true;
    }
  }

  resetHideModal(): void {
    this.hideModal = !this.hideModal;
    this.showDeleteFileModal = false;
    this.showTooLargeFileModal = false;
  }

  openFileDialog(){
    this.showTooLargeFileModal = false;
    if(this.fileUpload){
      this.fileUpload.nativeElement.click();
    }
  }

  cancelDeleteFile(){
    this.showDeleteFileModal = false;
    this.indxFiletoDelete = null;
  }

  confirmDeleteFile(){
    this.showDeleteFileModal = false;
    this.documents.splice(this.indxFiletoDelete, 1);
    this.indxFiletoDelete = null;
    this.uploadFileEvent.emit(this.documents);
  }

  // uploadFile(event) {
  //   const newFile: File = event.target.files[0];
  //   event.target.value = ''
  //   let isUploadedFileSizeValid = true;

  //   if(newFile.size > 20000 * 1024){
  //     this.showTooLargeFileModal = true;
  //     isUploadedFileSizeValid = false;
  //     return;
  //   }

  //   if(isUploadedFileSizeValid){
  //     this.documents = this.documents.concat(newFile);
  //     this.uploadFileEvent.emit(this.documents);
  //   }
  // }

  uploadFile(event: Event): void {
    const input = event.target as HTMLInputElement;
    const newFile: File | undefined = input.files?.[0];
    input.value = '';
  
    if (!newFile) return;
  
    // Max file size check (~20MB)
    const MAX_SIZE = 20000 * 1024;
    if (newFile.size > MAX_SIZE) return;
  
    // Allowed types including GIF
    const allowedExtensions = ['.pdf', '.jpg', '.jpeg', '.png', '.gif'];
    const allowedMimeTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/gif'];
  
    const fileName = newFile.name.toLowerCase();
    const fileType = newFile.type;
  
    const isExtensionAllowed = allowedExtensions.some(ext => fileName.endsWith(ext));
    const isMimeTypeAllowed = allowedMimeTypes.includes(fileType);
  
    if (!isExtensionAllowed || !isMimeTypeAllowed) return;
  
    // File passed all checks
    this.documents = [...this.documents, newFile];
    this.uploadFileEvent.emit(this.documents);
  }
  
  

  deleteFile(file: File, event: Event, index) {
    event.stopPropagation();
    event.preventDefault();

    this.indxFiletoDelete = index;
    this.showDeleteFileModal = true;
  }

  leavePage(event){
    this.showLeaveModal = false;

    if(event){
      this.documents = [];

      if (this.pendingNavigationUrl) {
        this.router.navigateByUrl(this.pendingNavigationUrl);
      }
    }
      this.pendingNavigationUrl = null;
  }

  ngOnDestroy(): void {
    window.removeEventListener('beforeunload', this.preventPageLeave);
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  getUploadedDocuments(): File[]{
    return this.documents;
  }

  setLeavePage(isLeavePage: boolean){
    this.isLeavePage = isLeavePage
  }
}
